export interface DataGridState {
  editState: Record<any, Record<string, boolean>>;
}

export function getRowEditState(state: DataGridState, id: any): Record<string, boolean> {
  return state.editState?.[id] ?? {};
}

export function editCells(state: DataGridState, id: any, fields: string[]) {
  const rowEditState = { ...getRowEditState(state, id) };

  for (let f of fields)
    rowEditState[f] = true;

  return { ...state, editState: { ...state.editState, [id]: rowEditState } };
}
